import { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import InputMask, { Props as InputMaskProps } from 'react-input-mask';
import { InputAdornment, type InputBaseComponentProps, type StandardTextFieldProps } from '@mui/material';
import { Input } from '@shared/widgets';

const useStyles = makeStyles({
  container: {
    // 'width': '50%',
  },
  uppercase: {
    'text-transform': 'uppercase',
  },
});

const getMatch = (text: string, re: RegExp): string => {
  const match = re.exec(text || '');
  if (match) return match[1];
  return '';
};

const MaskedInput = InputMask as unknown as React.FC<InputMaskProps>;

interface Props extends StandardTextFieldProps {
  inputProps?: InputBaseComponentProps;
  currencies?: string[];
  value: string;
  onBlur: () => void;
}

export const BankAccountInput = ({ inputProps = {}, value, currencies, onBlur, onChange, ...props }: Props) => {
  const [currency] = useState<string>('');
  const [textValue, setTextValue] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);
  const [textFocused, setTextFocused] = useState<boolean>(false);

  const classes = useStyles();

  useEffect(() => {
    const reText = /(.*?)[a-zA-Z]{0,3}$/gim;
    // const reCurrency = /([a-zA-Z]{0,3})$/gmi;
    setTextValue(getMatch(value, reText));
    // setCurrency(getMatch(value, reCurrency));
  }, [value, setTextValue]);

  useEffect(() => {
    if (textValue && textValue.indexOf('_') === -1 && !currency) setOpen(true);
  }, [textValue, currency, setOpen]);

  useEffect(() => {
    if (textValue && !textFocused && !open) onBlur();
  }, [textValue, textFocused, open, onBlur]);

  // const handleCurrencyChange = useCallback(
  //   (e) => {
  //     onChange({
  //       target: { value: textValue + e.target.value },
  //       currentTarget: {},
  //     });
  //   },
  //   [textValue, onChange],
  // );

  const currencyAdornment = (
    <InputAdornment position='end'>
      <span>{currencies?.join(' / ')}</span>
      {/*<Select
      value={currency}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      onChange={handleCurrencyChange}
    >
      <MenuItem value="USD">USD</MenuItem>
      <MenuItem value="EUR">EUR</MenuItem>
      <MenuItem value="CHF">CHF</MenuItem>
    </Select>*/}
    </InputAdornment>
  );
  return (
    <MaskedInput mask='******.99.99.' value={textValue} onChange={onChange} onFocus={() => setTextFocused(true)} onBlur={() => setTextFocused(false)}>
      {/* @ts-ignore */}
      {() => (
        <Input
          className={classes.container}
          label='Year of inheritance'
          margin='normal'
          required
          inputProps={{ ...inputProps }}
          InputProps={{ endAdornment: currencyAdornment }}
          {...props}
        />
      )}
    </MaskedInput>
  );
};
